import { RoomRequests } from '@/services/room.requests'
const roomService = new RoomRequests()

import { selectorValues } from '@/config'

const state = {
  list: [],
  modifiedRoomList: [],
  filteredRoomList: []
}
const getters = {
  getFirstFilteredRoomId: (state) => (roomInfoList) => {
    var room = state.filteredRoomList.find(room => room.id && !roomInfoList.some(disabledRoom => room.id === disabledRoom.roomId))
    return room ? room.id : selectorValues.NO_ROOM
  },
  getRoomName: (state) => (id) => {
    var room = state.list.find(room => room.id == id)
    return room ? room['name'] : null
  }
}

const actions = {
  list ({ state, commit }) {
    return new Promise((resolve, reject) => {
      roomService.list().then(async (rooms) => {
        state.list = rooms
        commit('modifiedRoomList')
        resolve(rooms)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  modifiedRoomList (state) {
    state.modifiedRoomList = state.list.map(room => {
      room['disabled'] = false
      return room
    })
    state.modifiedRoomList.unshift(selectorValues.NO_ROOM)
  },
  setModifiedRoomList (state, modifiedRoomList) {
    state.modifiedRoomList = modifiedRoomList
  },
  filteredRoomList (state, facilityId) {
    state.filteredRoomList = state.modifiedRoomList.filter(room => room.facilityId === facilityId || room === selectorValues.NO_ROOM)
  },
  setFilteredRoomList (state, filteredRoomList) {
    state.filteredRoomList = filteredRoomList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
